export const userReportService = {
  getUserReport: (data) => window.axios.post("get-all-user-report", data),
  getReportTitle: (data) => window.axios.post("get-all-report-title", data),
  addReportTitle: (data) => window.axios.post("add-report-title", data),
  showReportTitle: (data) => window.axios.post("show-report-title", data),
  updateReportTitle: (data) => window.axios.post("update-report-title", data),
  deleteReportReason: (data) => window.axios.post("delete-report-title", data),
};
